import React from 'react'
import { KeyPlayerItem } from './KeyPlayerItem'
import { getMatchupStatList } from '../../../../Utils'
import { KeyMatchup } from '../../../../Api/Events/events.types'
import { CompareCon } from '../styles'

type HeadToHeadProps = {
  matchup: KeyMatchup[]
}

export const HeadToHead: React.FC<React.PropsWithChildren<HeadToHeadProps>> = ({
  matchup,
}) => {
  return (
    <>
      {matchup && matchup.length > 1 && (
        <CompareCon>
          <h2 className="heading">Key Matchup</h2>
          <div className="playersContainer">
            <div className="team">
              {matchup[0] && (
                <KeyPlayerItem
                  player={matchup[0]}
                  statList={getMatchupStatList(matchup[0]?.position)}
                  side="left"
                />
              )}
            </div>
            <div className="divider" />
            <div className="team">
              {matchup[1] && (
                <KeyPlayerItem
                  player={matchup[1]}
                  statList={getMatchupStatList(matchup[1]?.position)}
                  side="right"
                />
              )}
            </div>
          </div>
        </CompareCon>
      )}
    </>
  )
}
